import React from 'react';
import { connect } from 'react-redux';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PromoPopupButton from 'apps/auth/components/common/Popup/PopupButton';
import PromoSimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { SEPA_FREE } from 'apps/auth/constants/FieldType';
import { CHINA } from 'apps/auth/constants/WellKnownCountries';

const AuthPromoTextPopup = (props) => {
    const getLinkForComment = () => {
        return <PromoPopupButton href={getLinkForTerms()} target="_blank" iconName="arrow-forward" text={props.offerTitle} />;
    };
    const getText = (text) => {
        return <DangerouslyHtml dangerouslyHtml={text} />;
    };

    const getLinkForTerms = () => {
        let url = '';
        if (props.countryToId === CHINA) {
            url = '//cloud.paysend.com/web/docs/promo_alipay_july_2021.pdf';
        } else if (props.type === SEPA_FREE) {
            url = '//cloud.paysend.com/web/docs/sepa_cashback.pdf';
        } else {
            url = '//cloud.paysend.com/web/docs/mastercard_hero_promo_action_ru.pdf';
        }
        return url;
    };

    return (
        <PromoSimplePopup popupRef={props.popupRef} text={getText(props.text)}>
            {props.isComment && getLinkForComment()}
            <PromoPopupButton
                iconName="check"
                text={props.feeLandingCloseTitle}
                onClick={(e) => {
                    e.preventDefault();
                    if (props.closeHandler) {
                        props.closeHandler(e);
                    } else {
                        props.popupRef.current?.close();
                    }
                }}
            />
        </PromoSimplePopup>
    );
};
const mapStateToProps = (state) => {
    return {
        lang: state.language.lang,
        country: state.app.country,
        offerTitle: state.messages.pageMessages.offerTitle,
        feeLandingChinaAlipayInfo: state.messages.pageMessages.feeLandingChinaAlipayInfo,
        feeLandingCloseTitle: state.messages.pageMessages.feeLandingCloseTitle,
    };
};

export default connect(mapStateToProps, null)(AuthPromoTextPopup);
